<template>
    <div class="background-image">

  <div>
    <h1 class=" text-center text-white pt-3">¡TRUCO O TRATO!</h1>
    <p class="text-center py-0 my-0 haloween">Concurso de disfraces 🎃 🎃</p>
    <p class="text-center text-white py-0 my-0">
      💀participa registrando tu correo y escoge a tu grupo favorito. Solo
      puedes votar por única vez. 💀
    </p>
    <div class="container">
      <input
        type="email"
        v-model="correo"
        class="form-control mt-5"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        placeholder="Ejemplo: @gruposolimano.com.pe o @people.com.pe"
      />
      <button @click="mandarCorreo()" class="btn btn-success w-100 mt-3">
        VOTAR
      </button>
      <h2 class="text-center haloween mt-1">🕷️¡Tienes 1 intento! 🕷️</h2>
    </div>
    <div class="container mt-5">
      <div class="row gx-6 gy-2">
        <div class="col col-12">
          <div class="border border-2 pb-0 my-0 py-0 d-flex">
            <img
              src="@/assets/haloweenimg/nominas.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />

            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-3"
                type="radio"
                v-model="opcionSeleccionada"
                value="1"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <div class="ms-1 mt-2">
                <p class="letra py-0 my-0">NOMINAS </p>
              <p class="letra py-0 my-0">TU</p>
              <p class="letra py-0 my-0">TERRROR</p>
              </div>
            

            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/tifany.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />

            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-3"
                type="radio"
                v-model="opcionSeleccionada"
                value="2"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />

                <div>
                  <p class="ms-1 my-0 py-0 letra ">GRUPO DE </p>
                  <p class="ms-1 my-0 py-0 letra "> TERROR Y </p>
                  <p class="ms-1 my-0 py-0 letra ">PESADILLAS</p>

                </div>
            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/uva.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />

            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-3"
                type="radio"
                v-model="opcionSeleccionada"
                value="3"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <p class="ms-1 letra mt-3">OPE UVA</p>
            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/gatitos.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />
            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-3"
                type="radio"
                v-model="opcionSeleccionada"
                value="4"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <div>
                <p class=" ms-2 py-0 my-0 letra">CHICAS SUPER</p>
                <p class=" ms-2 py-0 my-0 letra"> PODEROSAS</p>

              </div>
              

            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/sinNombre.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />
            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-1 me-2"
                type="radio"
                v-model="opcionSeleccionada"
                value="5"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <div>
                <p class="py-0 my-0 letra">LOS QUE </p>
                <p class="py-0 my-0 letra">NO TUVIMOS  </p>

              <p class="py-0 my-0 letra"> TIEMPO DE </p>
              <p class="py-0 my-0 letra">PONERNOS </p>
              <p class="py-0 my-0 letra">NOMBRE</p>

              </div>
             
            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/dalmatas.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />
            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-1"
                type="radio"
                v-model="opcionSeleccionada"
                value="6"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <div>
                <p class="ms-1 py-0 my-0 letra">CRUELA DE </p>
                <p class="ms-1 py-0 my-0 letra">BILL Y </p>
                <p class="ms-1 py-0 my-0 letra">LOS DALMATAS</p>

              </div>
            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/rata.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />
            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-3"
                type="radio"
                v-model="opcionSeleccionada"
                value="7"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <div class="">
                <p class="ms-1 my-0 py-0 letra">RATONES </p>
              <p class="ms-1 my-0 py-0 letra"> DE SHREK</p>
              </div>
              

            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/yucalaila.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />
            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-3"
                type="radio"
                v-model="opcionSeleccionada"
                value="8"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <div>
                <p class="ms-1 py-0 my-0 letra">ESCUELA</p>
                <p class="ms-1 py-0 my-0 letra">DE HOGWARTS</p>
              </div>
              

            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="border border-2 d-flex">
            <img
              src="@/assets/haloweenimg/mimo.jpeg"
              class="img-fluid"
              style="max-width: 200px; height: 200px"
              alt=""
            />
            <div class="d-flex align-items-center">
              <input
                class="form-check-input ms-3"
                type="radio"
                v-model="opcionSeleccionada"
                value="9"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <p class="ms-1 letra mt-3">MIMO</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
  name: "SolimanologEscogerGrupos",

  data() {
    return {
      correo: "",
      opcionSeleccionada: "",
    };
  },

  mounted() {},

  methods: {
    mandarCorreo() {


      if(this.opcionSeleccionada == ""){
        Swal.fire({
                icon: "error",
                title: `🎃 Escoger un Grupo!! 🎃`,
                text: "",
                footer: "",
        });
      }else{
        this.axios
        .put(
          `Webscraping/VotarPuntaje?conCorreo=${this.correo}&grupo=${this.opcionSeleccionada}`
        )
        .then((r) => {
          console.log(r.data);
          if(r.data){
            Swal.fire({
                position: "center",
                icon: "success",
                title: " 🧟En Halloween... ¡Todo el mundo tiene derecho a un buen susto! ¡Gracias por participar!🧟",
                showConfirmButton: true,
                // timer: 3200,
              });
              this.correo = ""
          }
        })
        .catch((error) => {
          console.log(error.response.data);
          Swal.fire({
                icon: "error",
                title: `🎃 ${error.response.data} 🎃`,
                text: "",
                footer: "",
        });

      })
      }

  
    },
  },
};
</script>

<style scoped>
strong {
  font-size: 1.35rem;
  color: white; /* Color del texto */
  text-shadow:
    -1px -1px 0 black,  
    1px -1px 0 black,
    -1px 1px 0 black,
    1px 1px 0 black; /* Contorno en negro */
}

.letra{
 font-size: 1.00rem;
 color: white; /* Color del texto */
  text-shadow:
    -1px -1px 0 black,  
    1px -1px 0 black,
    -1px 1px 0 black,
    1px 1px 0 black; /* Contorno en negro */

}

.haloween{
  color: orange;
  font-weight: 800;
  font-size: 1.43rem;
}

.background-image {
  background-image: url('@/assets/haloweenimg/halos.png');
  background-size: auto; /* Mantener el tamaño original de la imagen de fondo */
  background-repeat: repeat; 

}
</style>
